const initialState = {
  suggestion: {
    meta: {
      isShow: false
    },
    data: {
      suggestions: [],
      search: ''
    }
  },
  main: {
    sorter: 'return_one_year',
    filter: {
      page: 1,
      size: 10,
      type_id: 1,
      syariah: false,
      min_investment_gte: '-',
      im_id: 'all',
      sort: 'rating_one_year',
      search: '',
      stateFilter: false,
      stateSorter: false
    },
    meta: {},
    data: [],
    total: null
  },
  mi: {
    data: [],
    meta: {},
    filter: {
      text: ''
    }
  },
  chart: {
    data: {},
    meta: {},
    filter: {
      type: 'aum',
      period: '1y'
    }
  },
  detail: {
    data: {},
    meta: {}
  }
}

export default (state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case 'SET_PRODUCT_SUGGESTION_META':
      return {
        ...state,
        suggestion: {
          ...state.suggestion,
          meta: {
            ...state.suggestion.meta,
            [payload.field]: payload.payload
          }
        }
      }
    case 'SET_PRODUCT_SUGGESTION_DATA':
      return {
        ...state,
        suggestion: {
          ...state.suggestion,
          data: {
            ...state.suggestion.data,
            [payload.field]: payload.payload
          }
        }
      }
    case 'SET_PRODUCT_SUGGESTION_DATA_MULTIPLE':
      return {
        ...state,
        suggestion: {
          ...state.suggestion,
          data: {
            ...state.suggestion.data,
            ...payload.payload
          }
        }
      }
    case 'CLEAR_PRODUCT_SUGGESTION_DATA':
      return {
        ...state,
        suggestion: {
          ...state.suggestion,
          data: initialState.suggestion.data
        }
      }
    case 'SET_PRODUCT_MAIN_DATA':
      return {
        ...state,
        main: {
          ...state.main,
          data: payload.data,
          total: payload.total
        }
      }
    case 'SET_PRODUCT_FILTER_DATA':
      return {
        ...state,
        main: {
          ...state.main,
          filter: {
            ...state.main.filter,
            [payload.field]: payload.value
          }
        }
      }
    case 'SET_PRODUCT_SORTER_DATA':
      return {
        ...state,
        main: {
          ...state.main,
          sorter: payload
        }
      }
    case 'SET_PRODUCT_MI_DATA':
      return {
        ...state,
        mi: {
          ...state.mi,
          data: payload
        }
      }
    case 'SET_FILTER_PRODUCT_MI_DATA':
      return {
        ...state,
        mi: {
          ...state.mi,
          filter: {
            ...state.mi.filter,
            [payload.field]: payload.value
          }
        }
      }
    case 'SET_PRODUCT_CHART_DATA':
      return {
        ...state,
        chart: {
          ...state.chart,
          data: payload
        }
      }
    case 'SET_PRODUCT_DETAIL_DATA':
      return {
        ...state,
        detail: {
          ...state.detail,
          data: payload
        }
      }
    case 'SET_CLEAR_FILTER_PRODUCT':
      return {
        ...state,
        main: {
          ...state.main,
          filter: {
            page: 1,
            size: 10,
            type_id: 1,
            syariah: false,
            min_investment_gte: '-',
            im_id: 'all',
            sort: '',
            search: ''
          }
        }
      }
    default:
      return state
  }
}
